import { MerchantData } from '@nemuru-eng/js-api-client';
import { useFormContext } from 'react-hook-form';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { AutocompleteAddress } from '@/components/shared/components/NewContextForms/components/AutocompleteAddress/AutocompleteAddress';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface MerchantLegalAddressFormProps extends FormGridOptions {
  merchantData?: MerchantData;
}

export const MerchantLegalAddressForm = ({ merchantData, fullWidth, fieldVariant }: MerchantLegalAddressFormProps) => {
  if (useFormContext()) {
    return (
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        <AutocompleteAddress fieldVariant={fieldVariant} fieldNamesPrefix={'legalAddress'} hideAdditionalFields />
      </FormGridContainer>
    );
  }

  return (
    <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
      <TextFormField
        label={'STREET_ADDRESS'}
        value={merchantData?.legalAddress.formattedAddress}
        name={'legalAddress.address'}
      />
      <TextFormField
        label={'FLOOR_NUMBER'}
        value={merchantData?.legalAddress.floorNumber}
        name={'legalAddress.floorNumber'}
      />
      <TextFormField
        label={'DOOR_NUMBER'}
        value={merchantData?.legalAddress.doorNumber}
        name={'legalAddress.doorNumber'}
      />
      <TextFormField
        label={'BUILDING_LABEL'}
        value={merchantData?.legalAddress.building}
        name={'legalAddress.building'}
      />
    </FormGridContainer>
  );
};
